import { TagProps } from "primereact/tag";
import * as client from "../../../client";

/** Whole-dollar currency, e.g. 1234567.89 -> "$1,234,568". */
export const formatCurrency = (n: number): string =>
  `$${Math.round(n).toLocaleString("en-US")}`;

const fmt = formatCurrency;

/** A layer's limit of liability, e.g. "$5,000,000 xs $10,000,000". */
export const readableLayer = (layer: client.Layer): string => {
  const participation = layer.participation ?? layer.range;
  const hasExcess = layer.starting_point > 0;
  const isPartial = participation < layer.range;
  if (isPartial && hasExcess) {
    return `${fmt(participation)} part of ${fmt(layer.range)} xs ${fmt(
      layer.starting_point
    )}`;
  }
  if (isPartial) return `${fmt(participation)} part of ${fmt(layer.range)}`;
  if (hasExcess) return `${fmt(layer.range)} xs ${fmt(layer.starting_point)}`;
  return fmt(layer.range);
};

export const statusLabel = (status: client.PolicyApplicationStatus): string =>
  status.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

export const statusSeverity = (
  status: client.PolicyApplicationStatus
): TagProps["severity"] => {
  switch (status) {
    case "bound":
    case "issued":
    case "in_force":
      return "success";
    case "quoted":
      return "info";
    case "declined":
    case "lost":
    case "withdrawn":
    case "expired":
      return "danger";
    case "renewed":
      return "warning";
    default:
      return null;
  }
};

/** Badge for a resolved field's source; ``null`` for plain inherited fields. */
export const sourceBadge = (
  source: client.FieldSource
): { label: string; severity: TagProps["severity"] } | null => {
  switch (source) {
    case "overridden":
      return { label: "Overridden", severity: "info" };
    case "added":
      return { label: "Added", severity: "success" };
    case "removed":
      return { label: "Removed", severity: "danger" };
    default:
      return null;
  }
};
